import type theme from '#build/ui-pro/footer-columns'

// Recursively make all properties optional
type DeepPartial<T> = {
	[P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P]
}

export default {
	slots: {
		root: 'xl:grid xl:grid-cols-2 xl:gap-8',
		left: 'mb-10 lg:mb-0',
		center: 'grid grid-flow-col auto-cols-fr gap-2 sm:gap-8 xl:col-span-1 justify-items-start xl:justify-items-end sm:pt-8',
		right: 'mt-10 xl:mt-0',
		label: 'text-sm font-semibold',
		list: 'mt-6 space-y-1.5',
		item: 'relative',
		link: 'group text-sm flex items-center -mx-3 px-3 py-2 gap-1.5 focus-visible:outline-primary hover:underline underline-offset-2 decoration-2',
		linkLeadingIcon: 'size-5 shrink-0',
		linkLabel: 'truncate',
		linkLabelExternalIcon: 'size-3 absolute top-0 text-dimmed inline-block'
	},
	variants: {
		active: {
			true: {
				link: 'text-inverted bg-accented/15 rounded-xs font-medium'
			},
			false: {
				link: [
					'text-inverted hover:text-inverted',
					'transition-colors'
				]
			}
		}
	}
} satisfies DeepPartial<typeof theme>
